// NewTripForm.jsx
import React, { useEffect, useState } from "react";
import { createCategory, updateCategory } from "../../services/tripServices";

export default function NewCategoryForm({ initialData }) {

    const [formData, setFormData] = useState({
        name: initialData?.name || "",
        description: initialData?.description || "",
        type: initialData?.type || "",
        keywords: initialData?.keywords || "",
        thumbnailImage: null,
    });
   

    const [submitting, setSubmitting] = useState(false);
    const onSubmit = (e) => {
        e.preventDefault();
        setSubmitting(true);
        // Handle form submission logic here
        const newCatData = new FormData();
        newCatData.append("name", formData.name);
        newCatData.append("description", formData.description);
        newCatData.append("type", formData.type);
        newCatData.append("keywords", formData.keywords)
        if (formData.thumbnailImage) {
            newCatData.append("thumbnailImage", formData.thumbnailImage);
        }
        
        try {
            initialData ? updateCategory(initialData._id, newCatData).then(data => {
                alert("Category updated successfully!");
                setSubmitting(false);
            }) : createCategory(newCatData).then(data => {
                alert("Category created successfully!");
                setSubmitting(false);
            });
        }
        catch (error) {
            alert("Error creating category. Please try again.");
            setSubmitting(false);
        }
    };

    return (
        <section className="new-trip">
            <h1>{ initialData ? "Edit Category" : "Create New Category"}</h1>
            <div className="form-grid">
                <input value={formData.name} placeholder="Name" onChange={(e) => setFormData({...formData, name: e.target.value})} required />
                <select value={formData.type} onChange={(e) => setFormData({...formData, type: e.target.value})} required >
                    <option value="" disabled>Select Category Type</option>
                    <option value="tours">Tours</option>
                    <option value="treks">Treks</option>
                    <option value="expeditions">Expeditions</option>
                </select>
                <input value={formData.keywords} placeholder="Keywords (comma seperated)" onChange={(e) => setFormData({...formData, keywords: e.target.value})} />
                <input type="file" accept="image/*"  placeholder="Thumbnail Image URL" onChange={(e) => setFormData({...formData, thumbnailImage: e.target.files[0]})} required />
                
            </div>


            <textarea value={formData.description} cols={100} placeholder="Short Description" required onChange={(e) => setFormData({...formData, description: e.target.value})} />

            <button disabled={submitting} className="submit" onClick={onSubmit}>{submitting ? initialData ? "Updating..." : "Creating..." : initialData ? "Update Category" : "Create Category"}</button>
        </section>
    );
}
